// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".styles-module__errorMessageContainer___g4Rnm {\n  flex: 0 1 100%;\n  justify-content: center;\n}\n", "",{"version":3,"sources":["webpack://screens/business-profile-page/components/edit-profile-page/components/edit-profile-panel/components/profile-photos-section/styles.module.less"],"names":[],"mappings":"AAAA;EACE,cAAA;EACA,uBAAA;AACF","sourcesContent":[".errorMessageContainer {\n  flex: 0 1 100%;\n  justify-content: center;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"errorMessageContainer": "styles-module__errorMessageContainer___g4Rnm"
};
export default ___CSS_LOADER_EXPORT___;
